<ngx-ui-loader
  [fgsColor]="'#e65c00'"
  [pbColor]="'#e65c00'"
  [text]="'Traitement...'"
  [fgsType]="'ball-spin-clockwise'"
>
</ngx-ui-loader>
<app-modal-confirmation></app-modal-confirmation>
<router-outlet></router-outlet>
